import React, { useState, useEffect } from 'react'
import { Modal, Table } from 'rsuite'
import TablePagination from 'rsuite/lib/Table/TablePagination'
import { downloadDurableArticlesFile } from '../../../redux/actions/accountingExpenses'
import { isEmpty } from 'lodash-es'
import DownloadButton from '../../../components/buttons/downloadButton/downloadButton'
import { downloadFile } from '../../../utils/fileUtil'
import notification from '../../../utils/notification'
import { doneLoading, startLoading } from '../../../utils/loading'
import { DEFAULT_ERR_MSG } from '../../../constants/msgText'
import { budgetFormat } from '../../../utils/formatterUtil'

export default function ListOfAssetsTable({
  schema,
  loading,
  page = 1,
  displayLength = 5,
  defaultLengthMenu = [
    { value: 5, label: 5 },
    { value: 10, label: 10 },
    { value: 15, label: 15 },
  ],
  onReload = () => {},
  ...props
}) {
  const { Column, HeaderCell, Cell } = Table

  const fs = localStorage.getItem('fontSize')

  const [tableData, setTableData] = useState([])
  const [imgUrl, setImgUrl] = useState()
  const [isViewImg, setIsViewImg] = useState(false)

  useEffect(() => {
    setTableData(schema.values || [])
  }, [schema.values])

  const handleChangeLength = (dataKey) => {
    onReload(1, dataKey)
  }

  const handleChangePage = (dataKey) => {
    onReload(dataKey, displayLength)
  }

  const delay = (delayInms) => {
    return new Promise((resolve) => setTimeout(resolve, delayInms))
  }

  const onDisplayFile = async (data) => {
    try {
      const response = await downloadDurableArticlesFile(data.assetImg)

      if (response) {
        var blob = new Blob([response], { type: response.type })
        var urlCreator = window.URL || window.webkitURL
        var imageUrl = urlCreator.createObjectURL(blob)
        //console.log('id : ', `#${data.assetCode || data.id}`)
        var img = document.getElementById(`${data.assetCode || data.id}`)
        // console.log('img : ', img)
        // if (img == null) {
        //   var count = 1
        //   while (count <= 3) {
        //     console.log('console.log(count) ', count)

        //     if (img == null) {
        //       await delay(1000)
        //       img = document.getElementById(`#${data.assetCode || data.id}`)
        //     } else {
        //       count = 4
        //     }
        //     count++
        //   }
        // }

        img.src = imageUrl
      }
    } catch (e) {
      console.log('error', e)
    }
  }

  const onDownloadFile = async (data) => {
    startLoading()
    try {
      const response = await downloadDurableArticlesFile(data.assetImg)

      if (response) {
        downloadFile(response, data.assetCode || data.id)
      } else {
        notification.open('error', {
          title: DEFAULT_ERR_MSG,
          duration: 5000,
        })
      }
    } catch (e) {
      console.log('error', e)
      notification.open('error', {
        title: DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    doneLoading()
  }

  return (
    <>
      <Table
        wordWrap
        minHeight={350}
        autoHeight
        loading={loading}
        headerHeight={fs <= 15 ? undefined : fs < 16 ? 70 : fs <= 18 ? 75 : 50}
        data={tableData}
        style={{ marginTop: '20px' }}
      >
        <Column width={90} align="center" fixed="left">
          <HeaderCell>ลำดับ</HeaderCell>
          <Cell>
            {(_, index) => {
              return (page - 1) * displayLength + index + 1
            }}
          </Cell>
        </Column>
        <Column width={200}>
          <HeaderCell>รหัสครุภัณฑ์</HeaderCell>
          <Cell dataKey="assetCode" />
        </Column>
        <Column minWidth={300} width={300} flexGrow={1}>
          <HeaderCell>รายการ</HeaderCell>
          <Cell dataKey="assetName" />
        </Column>
        <Column minWidth={300} width={300} flexGrow={1}>
          <HeaderCell>รุ่น</HeaderCell>
          <Cell dataKey="assetModel" />
        </Column>
        <Column width={250}>
          <HeaderCell>ประเภทครุภัณฑ์</HeaderCell>
          <Cell dataKey="assetType" />
        </Column>
        <Column width={200} align="right">
          <HeaderCell>ราคาครุภัณฑ์</HeaderCell>
          <Cell>
            {(rowData) => {
              return budgetFormat(rowData.assetAmount)
            }}
          </Cell>
        </Column>
        <Column width={180} align="center">
          <HeaderCell>รูปภาพครุภัณฑ์</HeaderCell>
          <Cell>
            {(rowData) => {
              if (isEmpty(rowData.assetImg)) {
                return <span style={{ color: '#fb8a81' }}>* ไม่มีรูปภาพ</span>
              }

              var img = ['jpg', 'jpeg', 'png']
              var fileType = rowData.assetImg.split('.')[1]

              if (img.includes(fileType)) {
                onDisplayFile(rowData)

                return (
                  <div style={{ width: '100%', minWidth: 100, height: 100 }}>
                    <img
                      id={rowData.assetCode || rowData.id}
                      alt="รูปภาพครุภัณฑ์"
                      style={{ width: '50%', minWidth: 100, height: 100, cursor: 'pointer' }}
                      onClick={(data) => {
                        console.log(data.target)
                        setImgUrl(data.target.src)
                        setIsViewImg(true)
                      }}
                    />
                  </div>
                )
              } else {
                return (
                  <DownloadButton
                    onClick={() => {
                      onDownloadFile(rowData)
                    }}
                  ></DownloadButton>
                )
              }
            }}
          </Cell>
        </Column>
      </Table>
      <TablePagination
        lengthMenu={defaultLengthMenu}
        activePage={page}
        renderLengthMenu={(lengthMenu) => {
          return (
            <>
              {lengthMenu}
              {`รายการ/หน้า`}
            </>
          )
        }}
        renderTotal={(total) => {
          return <>{` ทั้งหมด ${total} รายการ`}</>
        }}
        displayLength={displayLength || 5}
        total={schema.totalSize || 0}
        onChangePage={handleChangePage}
        onChangeLength={handleChangeLength}
      />

      <Modal
        show={isViewImg}
        size="md"
        onHide={(e) => {
          setIsViewImg(false)
          setImgUrl('')
        }}
      >
        <Modal.Header>
          <Modal.Title></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div style={{ height: 'auto', margin: '0 auto', width: '100%', textAlign: 'center' }}>
            <img
              id="view_img"
              src={imgUrl}
              alt="รูปภาพครุภัณฑ์"
              style={{ width: '70%', minWidth: 250, maxHeight: '90hv' }}
              className="contact-img "
            />
          </div>
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
      </Modal>
    </>
  )
}
